import { isPetSeat } from "../filterers/SeatOptionsFilterer";

export const hasSelectedPetCabin = (passengers, trip) => {
    let selections = passengers.map(p => p.selectedAccommodation);
    let tripAccommodations = trip.passengerAccommodations;
    const selectedAccommodations = selections.map(code => tripAccommodations.find(a => a.ClassAbbr === code) || {});
    return selectedAccommodations.some(accommodation => isPetSeat(accommodation));
}